var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolivia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 10.5322 23.736 9.12605 23.2536 7.82611L12 7.30434L0.746391 7.82606C0.264 9.12605 0 10.5322 0 12C0 13.4678 0.264 14.874 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.874 24 13.4678 24 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746399 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0C6.84043 0 2.44191 3.2565 0.746399 7.82611Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolivia);
export default __webpack_public_path__ + "static/media/bolivia.a71846e86ad92cdc8009afe2ba0b181d.svg";
export { ForwardRef as ReactComponent };